import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["timeField", "checkbox", "hiddenInput", "additionalTextField", "textField"];

  connect() {
    this.parent = this.timeFieldTarget.parentNode;

    this.checkboxTarget.addEventListener("change", () => {
      let parentNode = this.checkboxTarget.parentNode.parentNode;
      if(this.checkboxTarget.checked){
        for (let i = parentNode.children.length - 3; i > 1 ; --i) {
          parentNode.children[i].remove();
        }
        this.hiddenInputTarget.name = "website[opening_hours]" + this.hiddenInputTarget.name;
      }else{
        var temp = this.timeFieldTarget.cloneNode(true);
        temp.className = "form-field-time";
        temp.children[1].children[0].children[0].name = "website[opening_hours]" + temp.children[1].children[0].children[0].name + "[][from]";
        temp.children[1].children[1].children[0].name = "website[opening_hours]" + temp.children[1].children[1].children[0].name + "[][to]";
        this.parent.insertBefore(temp, this.checkboxTarget.parentNode);

        this.hiddenInputTarget.name = this.hiddenInputTarget.name.replace("website[opening_hours]","");
      }
    });
  }

  addItem() {
    var temp = this.timeFieldTarget.cloneNode(true);
    temp.children[0].className = "remove-button";
    temp.className = "form-field-time";
    temp.children[1].children[0].children[0].name = "website[opening_hours]" + temp.children[1].children[0].children[0].name + "[][from]";
    temp.children[1].children[1].children[0].name = "website[opening_hours]" + temp.children[1].children[1].children[0].name + "[][to]";
    var div = this.checkboxTarget.parentNode.parentNode;
    var nodes  = div.querySelectorAll('.form-field-time');
    console.log(nodes[nodes.length - 1])
    this.parent.insertBefore(temp, nodes[nodes.length - 1].nextSibling);
    this.checkboxTarget.checked = false;
  }

  removeItem(e) {
    let requiredparent = e.target.parentNode;
    while (requiredparent.className != "form-field-time") {
      requiredparent = requiredparent.parentNode;
    }
    requiredparent.remove();
  }

  addTextfield({ params }){
    let parent = this.checkboxTarget.parentNode.parentNode
    let n = parent.children.length
    if (!this.checkboxTarget.checked){
      if (!document.getElementById(`added_custom_textfield_${params.id}`)) {
        if (!document.getElementById(`custom_textfield_${params.id}`)) {
          var textfield = document.getElementById("addition_text_field").cloneNode(true)
        } else{
          var textfield = document.getElementById(`custom_textfield_${params.id}`);
        }
        parent.insertBefore(textfield, parent.children[n-2])
        let child = textfield.firstElementChild;
        child.setAttribute("name", `website[opening_hours][${params.id}][][condition]`)
        child.setAttribute("required", "true")
        textfield.removeAttribute("style")
      }
    }
  }

  removeTextField({ params }){
    var textfield = document.getElementById(`custom_textfield_${params.id}`)
    if(params.status === "added"){
      var textfield = document.getElementById(`added_custom_textfield_${params.id}`);
      var button = document.getElementById(`add_button_${params.id}`)
      button.removeAttribute("disabled")
      textfield.remove()
    }else{
      var child = textfield.firstElementChild;
      // var button = document.getElementById(`custom_button_${params.id}`)
      // button.removeAttribute("disabled")
      child.removeAttribute("required")
      child.removeAttribute("name")
      textfield.style = "display: none";
    }
    
  }
}
